import { useState } from 'react';
import { Toast } from '@/lib/Toast';
import { ICompany } from '@/types/api/companies';
import CompanyContacts from './CompanyContacts';
import ConfirmData from './ConfirmData';
import { Home } from './Home';
import OccupationArea from './OccupationArea';
import SelectCompany from './SelectCompany';

export enum RegisterCompanySteps {
  HOME,
  SELECT_COMPANY,
  CONFIRM_DATA,
  OCCUPATION_AREA,
  COMPANY_CONTACTS,
}

type ICompanyData = Partial<ICompany>;

interface IViewProps {
  currentStep: RegisterCompanySteps;
  nextStep: () => void;
  onSuccess: () => void;
  isEditingCompany: boolean;
}

export const View = ({
  currentStep,
  nextStep,
  onSuccess,
  isEditingCompany,
}: IViewProps) => {
  const [companyData, setCompanyData] = useState<ICompanyData>({});

  const onAdvancedStepSelectCompany = (data: ICompanyData) => {
    setCompanyData(data);
    nextStep();
  };

  const onAdvancedStepInformContacts = () => {
    onSuccess();

    if (isEditingCompany) {
      Toast('success', 'Empresa editada com sucesso!');
      return;
    }

    Toast('success', 'Empresa configurada com sucesso!');
  };
  return (
    <>
      {
        {
          [RegisterCompanySteps.HOME]: <Home nextStep={nextStep} />,
          [RegisterCompanySteps.SELECT_COMPANY]: (
            <SelectCompany
              onAdvancedStep={onAdvancedStepSelectCompany}
              isEditingCompany={isEditingCompany}
            />
          ),
          [RegisterCompanySteps.CONFIRM_DATA]: (
            <ConfirmData
              companyData={companyData}
              setCompanyData={setCompanyData}
              onAdvancedStep={nextStep}
              onSuccess={onSuccess}
            />
          ),
          [RegisterCompanySteps.OCCUPATION_AREA]: (
            <OccupationArea
              companyData={companyData}
              setCompanyData={setCompanyData}
              onAdvancedStep={nextStep}
            />
          ),
          [RegisterCompanySteps.COMPANY_CONTACTS]: (
            <CompanyContacts
              companyData={companyData}
              onAdvancedStep={onAdvancedStepInformContacts}
            />
          ),
        }[currentStep]
      }
    </>
  );
};

export type { ICompanyData };
